import { toArray, toId, toText } from '../../../common/package/list';

export function normalizeProject(raw) {
    return {
        id: toId(raw?.id),
        name: toText(raw?.name, 'Proyecto sin nombre'),
        slug: toText(raw?.slug),
        description: toText(raw?.description),
        state: raw?.project_state ?? null,
        bootstrapPhase: raw?.bootstrap_phase ?? null,
        clientId: toId(raw?.client_id ?? raw?.client),
        updatedAt: raw?.updated_at ?? null,
    };
}

export function normalizeProjectDetail(raw) {
    return {
        ...normalizeProject(raw),
        clientName: raw?.client?.name ?? null,
        repositories: toArray(raw?.repositories).map((repo) => ({
            id: toId(repo.id),
            name: toText(repo.name),
            kind: repo.kind ?? null,
            defaultBranch: repo.default_branch ?? null,
        })),
        tiers: toArray(raw?.tiers).map((tier) => ({
            id: toId(tier.id),
            name: toText(tier.name),
            phase: tier.phase ?? null,
            state: tier.tier_state ?? null,
            breakdownState: tier.breakdown_state ?? null,
        })),
        teams: toArray(raw?.teams).map((team) => ({ id: toId(team.id), name: toText(team.name) })),
    };
}

export function normalizePlan(raw) {
    const versions = toArray(raw?.versions)
        .map((version) => ({
            number: Number.isFinite(version.number) ? version.number : null,
            state: version.state ?? null,
            updatedAt: version.updated_at ?? null,
        }))
        .sort((a, b) => (b.number ?? 0) - (a.number ?? 0));
    return {
        id: toId(raw?.id),
        name: toText(raw?.name, `Plan ${raw?.id ?? ''}`.trim()),
        projectId: toId(raw?.project_id),
        versions,
    };
}
